import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthProvider from './AuthProvider';
import Loading from './Loading';
import SignIn from './SignIn';
import NotAuthorized from './NotAuthorized';

export default ({ component: Component, roles = [], ...rest }) => (
  <AuthProvider>
    {({ auth }, containsRole) => (
      <Route
        {...rest}
        render={props => {
          if (1 === auth.fetching) {
            return <Loading />;
          } else if (2 === auth.fetching) {
            if (!roles.length) {
              return (
                <Redirect
                  to={{
                    pathname: '/',
                    state: {
                      from: props.location
                    }
                  }}
                />
              );
            } else if (containsRole(roles)) {
              return <Component {...props} />;
            }
            return <NotAuthorized />;
          } else {
            return <SignIn auth={auth} {...props} />;
          }
        }}
      />
    )}
  </AuthProvider>
);



// WEBPACK FOOTER //
// ./src/PrivateRoute.js